import { percentage } from '@conxai/react-kit';
export function calculateDeltaPercentage(solutionWeight, predictedWeight, decimals = 1) {
    return Number(percentage(solutionWeight - predictedWeight, predictedWeight).toFixed(decimals));
}
